/**
 * Uzbek mobile numbers. The backend is the source of truth for validation; these helpers only
 * give fast feedback in the form and format numbers for display.
 */

/** Digits of a local number without the 998 country code, at most 9. */
export function localDigits(input: string): string {
  const digits = input.replace(/\D/g, "");
  return (digits.startsWith("998") && digits.length > 9 ? digits.slice(3) : digits).slice(0, 9);
}

/** True when the input holds a complete 9-digit local number. */
export function isCompletePhone(input: string): boolean {
  return localDigits(input).length === 9;
}

/** "901234567" → "90 123-45-67" (formats partial input as the user types). */
export function formatLocal(input: string): string {
  const d = localDigits(input);
  const parts = [d.slice(0, 2), d.slice(2, 5), d.slice(5, 7), d.slice(7, 9)];
  return [parts[0], [parts[1], parts[2], parts[3]].filter(Boolean).join("-")]
    .filter(Boolean)
    .join(" ");
}

/** "901234567" → "+998901234567", the format sent to the API. */
export function toE164(input: string): string {
  return `+998${localDigits(input)}`;
}
